import { createAsyncThunk } from "@reduxjs/toolkit";
import { APP_PATH } from "../../api/backendPath";
import { toast } from '../../components/toast';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import i18n from "../../i18n";
// Fetch the nursing center profile
export const fetchNurseProfileReducer = createAsyncThunk(
  "profile/fetchNurseProfile",
  async (_ = {}, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const fullUrl = `${process.env.REACT_APP_API_URL}${APP_PATH.nurseCenterProfile}`;
      const response = await axiosPrivate.get(fullUrl);
      if (response?.data?.status === true || response?.status === 200) {
        return response.data.data;
      }
      const msg = response?.data?.message || i18n.t("toast.failedToFetchProfile");
      return rejectWithValue(msg);
    } catch (error) {
      const errMsg =
        error?.response?.data?.message || i18n.t("toast.errorFetchingTheProfile");
      return rejectWithValue(errMsg);
    }
  }
);

// Update the nursing center profile
export const updateNurseProfileReducer = createAsyncThunk(
  "profile/updateNurseProfile",
  async (payload, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const fullUrl = `${process.env.REACT_APP_API_URL}${APP_PATH.nurseCenterProfile}`;
      const response = await axiosPrivate.put(fullUrl, payload);
      if (response?.data?.status === true || response?.status === 200) {
        toast.success(response?.data?.message || i18n.t("toast.profileUpdatedSuccessfully"));
        return response.data.data;
      }
      const msg = response?.data?.message || i18n.t("toast.failedToUpdateProfile");
      toast.error(msg);
      return rejectWithValue(msg);
    } catch (error) {
      const errMsg =
        error?.response?.data?.message || i18n.t("toast.errorUpdatingTheProfile");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  }
);

// Upload an avatar image and return the stored S3 key / URL
export const uploadNurseAvatarReducer = createAsyncThunk(
  "profile/uploadNurseAvatar",
  async (file, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const formData = new FormData();
      formData.append("file", file);
      const fullUrl = `${process.env.REACT_APP_API_URL}${APP_PATH.uploadAvatar}`;
      const response = await axiosPrivate.post(fullUrl, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response?.data?.status === true || response?.status === 200 || response?.status === 201) {
        return response.data.data;
      }
      const msg = response?.data?.message || i18n.t("toast.failedToUploadImage");
      toast.error(msg);
      return rejectWithValue(msg);
    } catch (error) {
      const errMsg =
        error?.response?.data?.message || i18n.t("toast.errorUploadingTheImage");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  }
);
